module.exports = __webpack_public_path__ + "img/港口.55dbac36.svg";